import JSCookie from 'js-cookie'

const sessionPrefix = process.env.VUE_APP_SESSION_PREFIX
const tokenCookieName = `${sessionPrefix}:token`
const langCookieName = `${sessionPrefix}:lang`

export const TokenSession = {
    // js-cookie only stores strings: since v3 it no longer serializes objects
    // on its own, so the token has to be stringified here. The resulting cookie
    // value is byte-identical to the one v2 used to write, so sessions opened
    // before this change keep working.
    set: token => JSCookie.set(tokenCookieName, JSON.stringify(token)),
    unset: () => JSCookie.remove(tokenCookieName),
    get: () => {
        const token = JSCookie.get(tokenCookieName)
        if (!token) return null
        if (typeof token === 'object') return token
        try {
            return JSON.parse(token)
        } catch (e) {
            // A corrupted cookie must not take the whole app down on boot:
            // report no session so the user is sent to the login screen.
            return null
        }
    },
    formatToken: token => ({
        type: token.type || 'Bearer',
        token: token.accessToken,
        refreshToken: token.refreshToken,
    }),
}

export const LangSession = {
    set: token => JSCookie.set(langCookieName, token),
    unset: () => JSCookie.remove(langCookieName),
    get: () => JSCookie.get(langCookieName),
}

export default {
    Token: TokenSession,
    Lang: LangSession,
}
